import React from 'react';
import { Table } from 'semantic-ui-react';
import { datasetUrl } from '@/constants/urls';
import { columnTools, hasColumn } from '@/constants/fields';
import DatasetRowWrapper from '@/datasets/components/DatasetRowWrapper';
import CollectionDatasetTools from '../containers/CollectionDatasetTools';

const CollectionDatasetRow = ({
  category,
  className,
  code,
  columns = [],
  dataset,
  onCheckBoxClick,
  upward,
  theme,
}) => (
  <DatasetRowWrapper
    className={className}
    columns={columns}
    dataset={dataset}
    onCheckBoxClick={onCheckBoxClick}
    theme={theme}
  >
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <CollectionDatasetTools
          url={datasetUrl(dataset, '#')}
          upward={upward}
          category={category}
          code={code}
          dataset={dataset}
        />
      </Table.Cell>
    )}
  </DatasetRowWrapper>
);

export default CollectionDatasetRow;
